export const PIXELS_PER_MINUTE = 16;
export const PIXELS_PER_MILLIS = PIXELS_PER_MINUTE / (60 * 1000);
export const PHASE_GAP = 8;
